export class UserSettings
{
    theme = 'theme-default';
    isDarkMode = false;
    isSidebarOpen = false;
    presentationShowNextSlide = true;
};